  import {GridConfiguration, GridRequest} from "../../shared/grid/grid.model";
  export class Subsidiary {
    id: number;
    name: string;
    type: string;
    dateAdded: string;
    totalRevenue: string;
    revenue30Days: string;
    totalCovers: number;
    covers30Days: number;
    coversPM: number;
  }

  export class Venue {
    id: number;
    name: string;
    subsidiaries: Subsidiary[];
  }

  export class GroupDatabaseModel {
    id: number;
    name: string;
    venuesCount: number;
    dateAdded: string;
    totalRevenue: string;
    revenue30Days: string;
    totalCovers: number;
    covers30Days: number;
    coversPM: number;
    venues: Venue[];
  }

  export class GroupGridRequest extends GridRequest {

  }

  export class GroupGridConfiguration extends GridConfiguration {

    constructor() {
      super();
      this.columns = [
        {
          dataField: 'name',
          displayValue: 'Group'
        },
        {
          dataField: 'venuesCount',
          displayValue: 'Venues'
        },
        {
          dataField: 'dateAdded',
          dataType: 'date',
          format: 'dd/MM/yyyy'
        },
        'totalRevenue',
        'revenue30Days',
        'totalCovers',
        'covers30Days',
        {
          dataField: 'coversPM',
          caption: 'Covers (P/M)',
          format: function (options) {
            if (options && options !== 0) {
              return (Math.round(parseFloat(options) * 100) / 100).toFixed(2);
            }
            return '0.00';
          }
        }

      ];

      this.customSearch = [
        {
          fieldName: 'name',
          value: ''
        }
      ];

      this.selection = false;
      this.columnAutoWidth = true;
      this.sorting = { mode: 'single' };
    }


    mapGridRequest(gridRequest: GridRequest, loadOptions: any) {
      super.mapGridRequest(gridRequest, loadOptions);
      gridRequest.options.customSearch = this.customSearch;
    }
  }




// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/venues/group-database/group-database.model.ts